import { createContext, type FC, useContext } from 'react';
import {
  type CreateDataTableFromTemplateStepContext,
  type CreateDataTableFromTemplateStepContextProps,
} from '@/components/Studies/Templates/CreateDataTable/CreateDataTableFromTemplate.model.tsx';

const CreateDataTableFromTemplateContext = createContext<CreateDataTableFromTemplateStepContext | null>(null);

export const CreateDataTableFromTemplateProvider: FC<CreateDataTableFromTemplateStepContextProps> = ({
  children,
  value,
}) => {
  return (
    <CreateDataTableFromTemplateContext.Provider value={value}>{children}</CreateDataTableFromTemplateContext.Provider>
  );
};

export const useCreateDataTableFromTemplateContext = (): CreateDataTableFromTemplateStepContext => {
  const context = useContext(CreateDataTableFromTemplateContext);
  if (!context) {
    throw new Error('useCreateDataTableFromTemplateContext must be used within a CreateDataTableFromTemplateProvider');
  }
  return context;
};
